import React from 'react';
import { FormControlLabel } from 'src/components';
import alert from 'src/components/alert';
import { IdentificationStatus } from 'src/domains';
import { navigationRef } from 'src/hooks/navigation';
import LocalText from 'src/local';

export type IdentificationProps = {
  value?: IdentificationStatus;
  onFetchValues: () => {
    isFullnameFilled?: boolean;
    isGenderFilled?: boolean;
    isBirthdayFilled?: boolean;
    isAddressFilled?: boolean;
    isDirty?: boolean;
  };
};
export const Identification: React.FC<IdentificationProps> = ({
  value,
  onFetchValues,
}) => {
  if (!value || value === IdentificationStatus.REJECTED) {
    return (
      <FormControlLabel
        text={LocalText.screens.myProfile.identification.title}
        rightIcon={'chevron'}
        error={
          value === IdentificationStatus.REJECTED
            ? LocalText.screens.myProfile.identification.rejected
            : undefined
        }
        onPress={() => {
          const {
            isFullnameFilled,
            isGenderFilled,
            isBirthdayFilled,
            isAddressFilled,
            isDirty,
          } = onFetchValues();
          if (
            !isFullnameFilled ||
            !isGenderFilled ||
            !isBirthdayFilled ||
            !isAddressFilled ||
            isDirty
          ) {
            alert(
              '本人確認手続きの前に以下の項目を入力してください。', //LocalText.components.soundRecorder.deleteAlert.title,
              '' +
                (isFullnameFilled ? '' : '\n・本名') +
                (isGenderFilled ? '' : '\n・性別') +
                (isBirthdayFilled ? '' : '\n・生年月日') +
                (isAddressFilled ? '' : '\n・居住地情報') +
                (isDirty ? '\n・編集分が保存されてません' : ''),
              [
                { text: LocalText.common.ok },
                {
                  text: LocalText.common.no,
                  style: 'cancel',
                },
              ],
              { cancelable: false },
            );
          } else {
            navigationRef.current?.navigate('Identification');
          }
        }}
      />
    );
  }
  if (value === IdentificationStatus.PROCESSED) {
    return (
      <FormControlLabel text={LocalText.screens.myProfile.identification.processed} />
    );
  } else if (value === IdentificationStatus.APPROVED) {
    return (
      <FormControlLabel text={LocalText.screens.myProfile.identification.approved} />
    );
  }
  return null;
};
